import { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const LAST_ROUTE_KEY = 'blazin:last-route'
const AUTH_ROUTES = new Set(['/login', '/forgot-password'])

function safeStoredRoute(value) {
  if (!value || !value.startsWith('/') || value.startsWith('//')) return null

  try {
    const url = new URL(value, window.location.origin)
    if (url.origin !== window.location.origin || AUTH_ROUTES.has(url.pathname)) return null
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return null
  }
}

export function PwaRouteMemory() {
  const location = useLocation()
  const navigate = useNavigate()
  const launchHandled = useRef(false)
  const isPwaLaunch = new URLSearchParams(location.search).get('source') === 'pwa'

  useEffect(() => {
    if (launchHandled.current || !isPwaLaunch) return
    launchHandled.current = true

    const storedRoute = safeStoredRoute(localStorage.getItem(LAST_ROUTE_KEY))
    if (!storedRoute) {
      navigate('/', { replace: true })
      return
    }

    navigate(storedRoute, { replace: true })
  }, [isPwaLaunch, navigate])

  useEffect(() => {
    if (isPwaLaunch || AUTH_ROUTES.has(location.pathname)) return
    localStorage.setItem(LAST_ROUTE_KEY, `${location.pathname}${location.search}${location.hash}`)
  }, [isPwaLaunch, location.hash, location.pathname, location.search])

  return null
}
